import moment from 'moment';

export const getStaic = (path) => {
  return `${process.env.PUBLIC_URL}${path}`;
};

// 生成与后端 aitask._id 同构的 MongoDB ObjectId 字符串（24 位 hex），用作前端会话 sessionId。
// 结构：4 字节时间戳 + 16 位随机 hex，与后端 createId（new mongoose.Types.ObjectId()）兼容，
// 可作为 aitask 的 _id 直接落库。
export const createId = () => {
  const ts = Math.floor(Date.now() / 1000)
    .toString(16)
    .padStart(8, '0');
  const chars = '0123456789abcdef';
  let rand = '';
  for (let i = 0; i < 16; i++) {
    rand += chars[Math.floor(Math.random() * 16)];
  }
  return ts + rand;
};
export function debounce(fn, wait /** 等待时间 */, immediate /** 是否立刻执行一次 */) {
  const now = Date.now.bind(Date);
  let lastTime = 0;
  let timer = null;
  let params = null;
  let _this = null;

  function later() {
    const nowTime = now();

    if (nowTime - lastTime < wait) {
      // 如果还不够等待时间则继续等待
      const remainTime = wait - (nowTime - lastTime);

      timer = setTimeout(later, remainTime);
    } else {
      // 已到等待时间，执行回调
      debouncer.result = fn.apply(_this, params);

      timer = null;
      _this = null;
      params = null;
    }
  }

  function execute() {
    lastTime = now();
    _this = this;
    params = arguments;

    try {
      if (immediate && timer === null) {
        // 立刻执行一次
        debouncer.result = fn.apply(_this, params);
      }

      return debouncer.result;
    } finally {
      if (timer === null) {
        // 加入时间队列，等待执行
        timer = setTimeout(later, wait);
      }
    }
  }

  // 创建执行器
  const debouncer = {
    execute,
    result: null,
  };

  return debouncer;
}

export function getQueryVariable(variable) {
  var query = window.location.search.substring(1);

  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

export function dateDiff(timestamp) {
  var arrTimestamp = (timestamp + '').split('');
  for (var start = 0; start < 13; start++) {
    if (!arrTimestamp[start]) {
      arrTimestamp[start] = '0';
    }
  }
  timestamp = arrTimestamp.join('') * 1;

  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  // var halfamonth = day * 15;
  var month = day * 30;
  // var now = new Date().getTime();
  const now = new Date();
  var diffValue = now - timestamp;

  // 如果本地时间反而小于变量时间
  if (diffValue < 0) {
    return '不久前';
  }

  // 计算差异时间的量级
  var monthC = diffValue / month;
  var weekC = diffValue / (7 * day);
  var dayC = diffValue / day;
  var hourC = diffValue / hour;
  var minC = diffValue / minute;

  // 数值补0方法
  // var zero = function (value) {
  //   if (value < 10) {
  //     return '0' + value;
  //   }
  //   return value;
  // };

  // 使用
  if (monthC > 12) {
    // 超过1年，直接显示年月日
    return (function () {
      var date = new Date(timestamp);
      return moment(date).format('YYYY-MM-DD');
      // var date = Date.now.bind(timestamp);
      // return date.getFullYear() + '年' + zero(date.getMonth() + 1) + '月' + zero(date.getDate()) + '日';
    })();
  } else if (monthC >= 1) {
    return parseInt(monthC) + '月前';
  } else if (weekC >= 1) {
    return parseInt(weekC) + '周前';
  } else if (dayC >= 1) {
    return parseInt(dayC) + '天前';
  } else if (hourC >= 1) {
    return parseInt(hourC) + '小时前';
  } else if (minC >= 1) {
    return parseInt(minC) + '分钟前';
  }
  return '刚刚';
}

export const formatTime = (time, format) => {
  var date = new Date(time);
  return moment(date).format(format);
};

export const getQueryByLocation = (location) => {
  let query = {};
  //
  if (location) {
    let pairs = location.split('?')[1];
    if (pairs) {
      pairs = pairs.split('&');
      let len = pairs.length;
      for (let i = 0; i < len; i++) {
        let keyVals = pairs[i].split('=');
        query[keyVals[0]] = decodeURIComponent(keyVals[1]);
      }
    }
  }

  return query;
};

// export const shortTxt = (text, number) => {
//   if (!text) {
//     return
//   }
//   if (text.length > number) {
//     return {
//       text: text.substring(0, number) + '...',
//       hasMore: true
//     }
//   } else {
//     return {
//       text: text,
//       hasMore: false
//     }
//   }
// }

export const GetUrlParam = (url, paraName) => {
  // 　　　　var url = document.location.toString();
  var arrObj = url.split('?');

  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split('&');
    var arr;

    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=');

      if (arr != null && arr[0] === paraName) {
        return arr[1];
      }
    }
    return '';
  } else {
    return '';
  }
};

//合并数组并去重
export const mergeArray = function (arr1, arr2) {
  var _arr = [];
  for (let i = 0; i < arr1.length; i++) {
    _arr.push(arr1[i]);
  }
  for (let i = 0; i < arr2.length; i++) {
    var flag = true;
    for (var j = 0; j < arr1.length; j++) {
      if (arr2[i] === arr1[j]) {
        flag = false;
        break;
      }
    }
    if (flag) {
      _arr.push(arr2[i]);
    }
  }
  return _arr;
};

export const personData = function (number) {
  let personList = ['不限'];
  for (let i = 1; i < number; i++) {
    personList.push(`${i}`);
  }

  return personList;
};

//通过豪秒数，计算时分
export const showTimeBySecond = function (val) {
  val = val / 1000;
  var time = '';
  if (val < 60) {
    if (val < 10) {
      time = '00:00:0' + val;
    } else {
      time = '00:00:' + val;
    }
    return time;
  } else {
    var min_total = Math.floor(val / 60); // 分钟
    // var sec = Math.floor(val % 60); // 余秒

    if (min_total < 60) {
      if (min_total < 10) {
        time = '00:0' + min_total;
      } else {
        time = '00:' + min_total;
      }
      return time;
      // return min_total + "\t分钟" ;
    } else {
      var hour_total = Math.floor(min_total / 60); // 小时数
      var min = Math.floor(min_total % 60); // 余分钟
      if (min < 10) {
        time = hour_total + ':0' + min;
      } else {
        time = hour_total + ':' + min;
      }
      return time;
      // return hour_total + "\t小时" + min + "\t分钟" ;
    }
  }
};

export const compareToTime = (endTime) => {
  var currentTime = new Date().getTime();
  var isBe = false;

  if (endTime < currentTime) {
    isBe = true;
  }

  return isBe;
};

export const getWeek = function (time) {
  // time=parseInt(time)
  var date = new Date(time);
  var week;
  if (date.getDay() === 0) week = '周日';
  if (date.getDay() === 1) week = '周一';
  if (date.getDay() === 2) week = '周二';
  if (date.getDay() === 3) week = '周三';
  if (date.getDay() === 4) week = '周四';
  if (date.getDay() === 5) week = '周五';
  if (date.getDay() === 6) week = '周六';
  return week;
};

export const include = function (arr, item, isNumber) {
  return arr && arr.indexOf(isNumber ? item.toString() : item) > -1;
};
export const includeTEXT = function (arr, item, isNumber) {
  return arr && arr.indexOf(isNumber ? item.toString() : item) > -1;
};

//文件，图片，语音，视频的文字提醒
export const getPlaceholder = function (type) {
  var list = [
    '',
    '',
    '',
    '点此输入要收集的附件名称',
    '点此输入要收集的图片名称',
    '点此输入要收集的语音名称',
    '点此输入要收集的视频名称',
  ];
  type = Number(type);
  if (type === 15) {
    type = 4;
  }
  if (list[type]) {
    return list[type];
  } else {
    return '';
  }
};
//字符串转数组
export const getFiledName = function (type) {
  var list = ['', '', '', '选择从微信上传文件', '上传图片', '上传语音', '上传视频'];
  type = Number(type);
  if (type === 15) {
    type = 4;
  }
  if (list[type]) {
    return list[type];
  } else {
    return '';
  }
};

export const bookTimeCheck = function (item, bookEndRuleMode, bookEndRule) {
  var currentDate = new Date().getTime();
  var daySeconds = 24 * 3600 * 1000;
  var endBookTime = '';
  var isBook = false;
  var datestr = item.date;
  datestr = formatTime(datestr, 'YYYY-MM-DD');
  datestr = `${datestr} 00:00`;
  var date = new Date(datestr).getTime();

  var startTime = item.startTime;

  if (bookEndRuleMode === 'everyday') {
    //每日规律  当天  前一天
    if (bookEndRule < 0) {
      //前一天
      endBookTime = date - daySeconds - bookEndRule;
    } else {
      //当天
      endBookTime = date + bookEndRule;
    }
  } else if (bookEndRuleMode === 'beforeStart') {
    //开始前
    endBookTime = startTime + bookEndRule;
    //endBookTime=currentDate
  } else if (bookEndRuleMode === 'extractTime') {
    //精确时间
    endBookTime = bookEndRule;
  }
  if (endBookTime < currentDate) {
    isBook = true;
  }

  return isBook;
};
//判断是否开发时间段
export const jugeOpenBookTime = function (openBookRecyleRuleForm) {
  var openBookRecyleRule = openBookRecyleRuleForm;
  var beforeUnitCount = openBookRecyleRule.beforeUnitCount; //几周/未来几天
  var unit = openBookRecyleRule.unit; //1代表周为单位，0为天
  var unitStartDay = openBookRecyleRule.unitStartDay; //周几 ，0为周日
  var unitStartTime = openBookRecyleRule.unitStartTime; //时间点
  // let choseHour=unitStartTime/(3600*1000)
  // let sT=choseHour % 1
  // let intStr=parseInt(choseHour)
  var currentDate = new Date().getTime(); //当前时间
  // let isBook = false  //true 为没有开放
  let dayTime = 24 * 60 * 60 * 1000;
  let dateTimestr = formatTime(currentDate, 'YYYY-MM-DD');
  dateTimestr = `${dateTimestr} 00:00`;
  let dateTime = new Date(dateTimestr).getTime();
  let currentDay = new Date().getDay();
  let endBookTime = dateTime - (7 - unitStartDay + currentDay) * dayTime;

  if (unit) {
    //以周为单位
    if (currentDay === unitStartDay) {
      // let dateTime=formatTime(currentDate,'YYYY-MM-DD')
      let currentTime = currentDate - dateTime; //获取当前时间的时分的时间点
      if (currentTime >= unitStartTime) {
        //判断时间点和当前时间的时间点的对比，如果大于设置的时间点，开放到下周
        endBookTime = [7 - unitStartDay + beforeUnitCount * 7] * dayTime; //最晚可以预约的时间点
        endBookTime = dateTime + endBookTime + dayTime;
      } else {
        endBookTime = dateTime - (7 - unitStartDay + currentDay) * dayTime;
        endBookTime = [7 - unitStartDay + 1 + beforeUnitCount * 7] * dayTime + endBookTime; //最晚可以预约的时间点
      }
    } else if (currentDay < unitStartDay || !unitStartDay) {
      endBookTime = dateTime - (7 - unitStartDay + currentDay) * dayTime;
      endBookTime = [7 - unitStartDay + 1 + beforeUnitCount * 7] * dayTime + endBookTime; //最晚可以预约的时间点
    } else {
      //大于周几
      endBookTime = [7 - currentDay + 1 + beforeUnitCount * 7] * dayTime; //最晚可以预约的时间点
      endBookTime = dateTime + endBookTime;
    }
  } else {
    //以天为单位
    let currentTime = currentDate - dateTime; //获取当前时间的时分的时间点
    if (currentTime >= unitStartTime) {
      //可以预约未来几天的时间
      endBookTime = beforeUnitCount * dayTime; //最晚可以预约的时间点
      endBookTime = dateTime + endBookTime + dayTime;
    } else {
      endBookTime = beforeUnitCount * dayTime; //最晚可以预约的时间点
      endBookTime = dateTime - dayTime + endBookTime + dayTime;
    }
  }

  return endBookTime;
};

//判断是否是图片

// export const isImage=function(filePath){

//   var suffix = filePath.substring(filePath.lastIndexOf('.') + 1);//获取后缀名
//   var isBe=false
//   var result=-1
//   if(suffix!=""){
//     suffix = suffix.toLocaleLowerCase();
//     // 图片格式
//     var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
//     // 进行图片匹配
//     result = imglist.indexOf(suffix)
//   }
//   if(result!==-1){
//     isBe=true
//   }
//     return isBe;

// }

//获取文件名
export const getFileName = function (fileName) {
  var name = fileName.replace('?x-oss-process=style/baoming_img_thumb', '');
  var len = fileName.length;

  // if(fileName.indexOf('_')>-1){
  //    name= fileName.substring(fileName.lastIndexOf('_') + 1);
  // }
  if (fileName.indexOf('_') > -1) {
    //  name= fileName.substring(fileName.lastIndexOf('_') + 1);
    var len_ = fileName.indexOf('_');
    name = fileName.slice(len_ + 1, len);
  }
  // name = name.slice(17, len)

  return name;
};

export const getOption = function (arr, index, obj, isOption) {
  var textObj = {
    text: '暂无',
  };
  //var text="暂无"

  if (obj.skipToFormId) {
    var array = obj.skipToFormId.split(',');
    for (var i = 0; i < arr.length; i++) {
      var str = '';
      if (isOption) {
        str = index + '-' + arr[i].id;
      } else {
        str = arr[i].id;
      }

      if (array.indexOf(str) > -1) {
        textObj.text = arr[i].title;
        textObj.order = arr[i].order + 1;
      }
    }

    // 跳转到末尾
    if (isOption) {
      var endStr = index + '-__end__';
      if (array.indexOf(endStr) > -1) {
        textObj.isEnd = true;
        textObj.order = '末尾';
      }
    } else {
      // 题目级：任一跳转目标以 __end__ 结尾即视为跳转到末尾
      for (var j = 0; j < array.length; j++) {
        if (array[j].indexOf('__end__') > -1) {
          textObj.isEnd = true;
          textObj.order = '末尾';
          break;
        }
      }
    }
  }

  return textObj;
};

export const getStrToArray = function (map) {
  var array = [];
  if (map) {
    array = Object.keys(map);
  }
  return array;
};

export const getConditions = function (arr, value) {
  var text = '依赖于';

  var infoMap = {};

  for (let i = 0; i < value.length; i++) {
    var obj = value[i];
    infoMap[value[i].id] = obj;
  }
  if (arr && arr.length > 0) {
    for (let i = 0; i < arr.length; i++) {
      if (infoMap[arr[i].optionId]) {
        var indexs = arr[i].optionIdxs.split(',');
        var array = [];
        for (var j = 0; j < indexs.length; j++) {
          var num = parseInt(indexs[j]) + 1;
          array.push(num);
        }
        var str = array.join('、');
        var int = parseInt(infoMap[arr[i].optionId].order) + 1;
        text = `${text}第${int}题第${str}个选项;`;
      }
    }
  }

  return text;
};

export const drawCodeCanvas = (canvasName, url, name, cb) => {
  // this.setState({ isCopyCode: true })
  var c = document.getElementById(canvasName);
  // //context对象
  var ctx = c.getContext('2d');

  ctx.fillStyle = '#ffffff';

  ctx.fillRect(0, 0, 250, 250);

  ctx.fillStyle = '#333333';
  // let centerLine = 100
  ctx.textAlign = 'center';
  // ctx.fillText("扫码推广", centerLine, 30);

  let img = new Image();
  img.setAttribute('crossOrigin', 'anonymous');
  img.onload = function () {
    ctx.drawImage(img, 10, 10, img.width / 2, img.height / 2);

    // ctx.fillText(name, centerLine, 180);
    let base64Image = c.toDataURL('image/jpeg', 0.95);

    cb(base64Image);
  };

  img.src = url;

  // var downloadLink = document.getElementById('downloadLink');
  //   downloadLink.setAttribute('href', url);
  //   downloadLink.setAttribute('download', '二维码.png');
  //   downloadLink.click();
};

// //获取信息
// export const getInfoValue = function (value, infoForm,name) {

//   var value = Number(value)
//   for (let i = 0; i < infoForm.length; i++){
//     if (infoForm[i].title === name) {
//       if (infoForm[i].type === "1") {
//         infoForm[i].options
//       }
//     }
//   }
//   return options[value]

// }

export const showOption = (options, sidx) => {
  return options[parseInt(sidx, 10)];
};

export const getMinutes = (startTime, endTime) => {
  const date1 = moment(startTime, 'hh:mm');
  const date2 = moment(endTime, 'hh:mm');
  const date3 = date2.diff(date1, 'minute'); //计算相差的分钟数
  return date3;
};

export const getMapByArray = (arr, name, val, baomingVal) => {
  var obj = '';
  if (arr) {
    for (var i = 0; i < arr.length; i++) {
      var key = arr[i][name];
      if (key.toString() === val.toString()) {
        if (arr[i].value !== baomingVal) {
          obj = arr[i];
          break;
        }
      }
      // map[key] = arr[i]
    }
  }
  return obj;
};

export const hasOtherFun = (str) => {
  var hasOther = false;
  // if(!parseInt(str,10)&&parseInt(str)!==0){
  //   hasOther=true
  // }
  if (str && typeof str === 'string' && str.indexOf('_') > -1) {
    hasOther = true;
  }
  return hasOther;
};
//显示的时候去掉下划线
export const expressOther = (str) => {
  var name = str;
  name = str.substring(1);
  return name;
};

export const commasToArr = (str) => {
  if (str) {
    return str.split(',');
  } else {
    return [];
  }
};
//字符串转数组
export const getArrayToStr = (str, spl) => {
  const splStr = spl || ',';
  if (str && str.length > 0) {
    return str.split(splStr);
  } else {
    return [];
  }
};

export const intToArray = (int) => {
  var arr = [];
  for (var i = 0; i < int; i++) {
    arr.push('');
  }
  return arr;
};
export const isImage = (filePath) => {
  var suffix = filePath.substring(filePath.lastIndexOf('.') + 1); //获取后缀名

  suffix = suffix && suffix.toLocaleLowerCase();
  var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];

  return imglist.indexOf(suffix) > -1;
};

export const isVideo = (filePath) => {
  var suffix = filePath.substring(filePath.lastIndexOf('.') + 1); //获取后缀名

  suffix = suffix && suffix.toLocaleLowerCase();
  var imglist = ['mp4'];

  return imglist.indexOf(suffix) > -1;
};

export const isInCheckMedia = (val) => {
  if (val && val.indexOf('incheck.jpg') > -1) {
    return true;
  } else {
    return false;
  }
};
export const shortTxt = (text, number) => {
  if (!text) {
    return;
  }
  if (text.length > number) {
    return {
      text: text.substring(0, number) + '...',
      hasMore: true,
    };
  } else {
    return {
      text: text,
      hasMore: false,
    };
  }
};

export const getCheckUrl = (name) => {
  if (name && name.indexOf('incheck.jpg_') > -1) {
    name = name.replace('incheck.jpg_', '');
  }
  return name;
};

export const getPreviewUrl = function (name) {
  if (name && name.indexOf('?x-oss-process=style/baoming_img_thumb') > -1) {
    name = name.replace('?x-oss-process=style/baoming_img_thumb', '');
  }
  return name;
};

export const getInlineVak = (baoming, option) => {
  var val = hasOtherFun(
    getMapByArray(baoming.managerUpdateVal, 'id', [option.id || option.title + '_' + option.order])
      .value,
  )
    ? expressOther(
        getMapByArray(baoming.managerUpdateVal, 'id', [
          option.id || option.title + '_' + option.order,
        ]).value,
      )
    : getMapByArray(baoming.managerUpdateVal, 'id', [
        option.id || option.title + '_' + option.order,
      ]).value
    ? showOption(
        option.options,
        getMapByArray(baoming.managerUpdateVal, 'id', [
          option.id || option.title + '_' + option.order,
        ]).value,
      )
    : '空';
  return val;
};
var lastItemByUrl = function (thePath) {
  var image = thePath;
  if (thePath && thePath.indexOf('http') > -1) {
    image = thePath.substring(thePath.lastIndexOf('/') + 1);
  }
  return image;
};
//判断批图的图片跟原图对应
export const confirmImage = (arrStr, item, isNumber) => {
  var image = item;
  if (item.indexOf('replace_') === -1) {
    var img = lastItemByUrl(item);
    image = 'replace_' + img;
  }
  if (arrStr && arrStr.length > 0) {
    var array = arrStr.split(',');
    var arr = [];
    for (var a = 0; a < array.length; a++) {
      arr.push(lastItemByUrl(array[a]));
    }
    var itemIndex = arr && arr.indexOf(isNumber ? image.toString() : image);
    console.log('image', image);
    console.log('arr', arr, arr.indexOf(image));
    if (itemIndex > -1) {
      return arr[itemIndex];
    } else {
      return item;
    }
  } else {
    return item;
  }
};

export const getTongjiLogo = (wxLogo, userAvatar) => {
  if (!wxLogo) {
    return 'https://cdn-www.hui51.cn/logo.png';
  }
  if (wxLogo === 'https://cdn-www.hui51.cn/logo.png') {
    return userAvatar;
  } else {
    //update 4/6 如果是审核中的话就显示审核中的图片
    if (wxLogo.indexOf('incheck.jpg') > -1) {
      return 'https://cdn-www.hui51.cn/logo.png';
    } else {
      if (
        wxLogo.indexOf('//hui51.oss-cn-beijing.aliyuncs.com/') > -1 ||
        wxLogo.indexOf('//oss.hui51.cn/') > -1 ||
        wxLogo.indexOf('//oss2.hui51.cn/') > -1
      ) {
        var replaceUrl = wxLogo
          .replace('hui51.oss-cn-beijing.aliyuncs.com', 'cdn.hui51.cn')
          .replace('oss.hui51.cn', 'cdn.hui51.cn')
          .replace('oss2.hui51.cn', 'cdn.hui51.cn');

        return replaceUrl;
      } else {
        return wxLogo;
      }
    }
  }
};

//然后通过下面的函数将dataURL转为Blob文件
export const dataURLtoBlob = (dataurl) => {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = window.atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

export const dataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = window.atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export const getDakaFreName = (days) => {
  var names = ['日', '一', '二', '三', '四', '五', '六'];
  console.log('哈哈哈哈哈哈：', days.length);
  if (days.length === 7) {
    return '每天';
  } else {
    var nameArr = [];
    for (var i = 0; i < days.length; i++) {
      nameArr.push(names[days[i]]);
    }
    console.log('get nameArr', nameArr);
    return '每周' + nameArr.join('、');
  }
};

export const keyBy = (objArr, key) => {
  const toReturn = {};
  if (objArr && objArr.length > 0) {
    for (let idx = 0; idx < objArr.length; idx++) {
      const item = objArr[idx];
      if (item) {
        toReturn[item[key]] = item;
      }
    }
  }
  return toReturn;
};
export const map = (arr, name) => {
  let out = [];
  let len = arr.length;
  for (let i = 0; i < len; i++) {
    out.push(arr[i][name]);
  }
  return out;
};

export const hadRem = function (name) {
  var had = false;
  if (name && name.indexOf('replace_') > -1) {
    had = true;
  }
  return had;
};

//ispreview 判断是否是查看
export const expressFileUrl = (url, oName, path, ispreview, rem) => {
  console.log(url, '---', oName, '---', path, '---', ispreview, '---', rem);
  var baseUrl = 'http://' + oName + '.hui51.cn/' + path;
  // var baseUrl = url.indexOf('replace')!==-1?'http://hui51.oss-cn-beijing.aliyuncs.com/'+path:'http://' + oName + '.hui51.cn/' + path

  var uuid = Math.floor(Math.random() * 2000);
  var fileUrl = '';

  if (url.indexOf('http') > -1) {
    if (path === 'videos' || path === 'audios') {
      fileUrl = url.replace('?x-oss-process=style/baoming_img_thumb', '');
    } else {
      fileUrl = url;
    }
  } else {
    fileUrl = baseUrl + '/' + url;
  }
  if (rem) {
    fileUrl += '?rem=' + uuid;
    if (url.indexOf('http') === -1) {
      if (isImage(url) && !ispreview) {
        fileUrl += '&x-oss-process=style/baoming_img_thumb';
      }
    }
  } else {
    if (url.indexOf('http') === -1) {
      if (isImage(url) && !ispreview) {
        fileUrl += '?x-oss-process=style/baoming_img_thumb';
      }
    } else {
      if (url.indexOf('thumb') !== -1) {
        var sUrl = url.split('?')[0];
        if (ispreview && isImage(sUrl)) {
          fileUrl = sUrl;
        }
      }
    }
  }
  if (ispreview) {
    fileUrl = fileUrl.replace('?x-oss-process=style/baoming_img_thumb', '');
  }
  return fileUrl;
};

export const getMarkValues = (markvalues) => {
  var array = markvalues ? markvalues.split(',') : [];
  var values = [];
  var markvalue = markvalues;
  if (markvalues && array && array.length > 0) {
    for (var i = 0; i < array.length; i++) {
      var thePath = array[i];
      if (thePath && thePath.indexOf('http') > -1) {
        thePath = thePath.substring(thePath.lastIndexOf('/') + 1);
      }
      values.push(thePath);
    }
    if (values && values.length > 0) {
      markvalue = values.toString();
    }
  }
  return markvalue;
};
// 有图片的时候返回title/isImage/imageUrl
export const showOptionObj = (options, sidx) => {
  // console.log(sidx,options)
  return options[parseInt(sidx, 10)];
};

// 判断optionFrom是否有图片
export const hadImage = function (optionForms) {
  var hasImage = false;

  for (var i = 0; i < optionForms.length; i++) {
    if (optionForms[i].isImage || optionForms[i].isVideo) {
      hasImage = true;
      return hasImage;
    }
  }
  return hasImage;
};
export const getHourCountByDuration = function (minutes) {
  //canUpdateDuration除以60就，整数部分是小时，
  var obj = {
    hour: Math.floor(minutes / 60),
    minutes: minutes % 60,
  };
  return obj;
};

// 自增表单报名表格的宽度
export const getEditGroupFormValTableWidth = function (item, baomingForm) {
  var colCount =
    item.groupInfoForms.length +
    (baomingForm &&
    baomingForm[item.id || item.title + '_' + item.order] &&
    baomingForm[item.id || item.title + '_' + item.order].length > 0
      ? 1
      : 0);
  return colCount * 25 > 100 ? colCount * 25 : 100;
};

export const getTableNewWidth = function (colCount) {
  return colCount * 75 + 100;
};

export const getMoreTypeName = (type) => {
  var moreTypeMap = {
    0: '填空题',
    1: '选择题',
    2: '多选题',
    3: '收集文件',
    4: '收集图片',
    5: '收集语音',
    6: '收集视频',
    7: '多行文本',
    8: '日期',
    9: '数字',
    10: '省市区',
    11: '手机号码',
    12: '身份证号码',
    13: '出生日期',
    14: '知情确认',
    15: '收集拼图',
    16: '评分',
    17: '矩阵单选',
    18: '矩阵多选',
    19: '自增表格',
    20: '多项填空',
    21: '签名',
    22: '地点',
    23: '扫码录入',
    24: '选课系统',
    31: '性别',
    32: '民族',
    33: '政治面貌',
    34: '学历',
    35: '水印拍照',
    36: '年龄',
    37: '车牌号',
    38: '邮箱',
    39: '下拉选择题',
  };
  return moreTypeMap[type];
};

// 获取按周打卡的截止或提醒时间显示
export const getWeekRuleTimeForDiaplay = function (weekTime) {
  // "08:00 1"
  var weekStrs = ['日', '一', '二', '三', '四', '五', '六'];
  if (weekTime && weekTime.indexOf(' ') > -1) {
    var times = weekTime.split(' ');
    var time = times[0];
    var weekIdx = parseInt(times[1], 10);
    return '每周' + weekStrs[weekIdx] + ' ' + time;
  }
  return '';
};
// 某时间的年份、月份、当月第几周等
export const getDateInfos = function (time) {
  var date = new Date(time);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  var d = date.getDate();
  var weekIdx = Math.floor((d - 1) / 7);
  return {
    year: y,
    month: m,
    date: d,
    weekIndex: weekIdx,
  };
};

// type：不同类型的格式
// 0 2022年12月第2周
// 1 第2周 (11月14日~11月20日)
export const getWeekDakaDateFormDiaplay = function (time, type) {
  var infos = getDateInfos(time);
  if (type === 1) {
    var mondayTime = new Date(time).getTime();
    var sundayTime = mondayTime + 7 * 86400000;
    return (
      '第' +
      (infos.weekIndex + 1) +
      '周 (' +
      formatTime(mondayTime, 'MM月DD日') +
      '~' +
      formatTime(sundayTime, 'MM月DD日') +
      ')'
    );
  }
  return infos.year + '年' + infos.month + '月第' + (infos.weekIndex + 1) + '周';
};

export const getWeekDate = function (weekTime, index) {
  const weekTimes = weekTime ? weekTime.split(' ') : [];
  var week = parseInt(weekTimes[1] || '0');
  week = week === 0 ? 6 : week - 1;
  var time = weekTimes[0];
  if (index === 1) {
    return week;
  } else {
    return time;
  }
};
// 获取某日期所在周的周一、日
export const getWeekDates = (time) => {
  time = time || Date.now();
  const weekOfday = moment(time).format('E'); //计算指定日期是这周第几天
  const sunday = moment(time)
    .add(7 - weekOfday, 'days')
    .format('YYYY-MM-DD'); //周日日期
  const result = {
    0: sunday,
  };
  for (let i = 1; i < 7; i++) {
    result[i] = moment(time)
      .subtract(weekOfday - i, 'days')
      .format('YYYY-MM-DD');
  }
  return result;
};

export const getYears = (min, max) => {
  const minY = new Date(min).getFullYear();
  let maxY = new Date(max).getFullYear() + 1;
  const current = new Date().getFullYear() + 5;
  if (current > maxY) {
    maxY = current;
  }

  const arr = [];
  for (let i = minY; i < maxY; i++) {
    arr.push(i);
  }
  return arr;
};
const fomatFloat = (src, pos) => {
  return Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos);
};

//求百分比
export const getPercent = function (total, count) {
  var percent = 0;
  count = parseInt(count) || 0;
  if (total) {
    percent = fomatFloat((count / parseInt(total)) * 100, 1);
  }
  return percent;
};

export const getIdsByField = function (infoForms, name) {
  var infoKeys = [];
  if (infoForms && infoForms.length > 0) {
    infoKeys = infoForms.map(function (item) {
      return item[name];
    });
  }
  return infoKeys;
};

export const mergerIdName = function (arr, obj, name) {
  var idx = -1;
  if (arr && arr.length > 0) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i][name] === obj[name]) {
        idx = i;
        break;
      }
    }
  }
  return idx;
};

export const includeAll = function (arr, item) {
  return arr && (arr.indexOf(item.toString()) > -1 || arr.indexOf(item) > -1);
};
export const getVoteRules = function (isBe) {
  //isBe的时候是匿名，
  var defalutList = [
    '投票后可看票数',
    '投票后可看票数和明细',
    '仅管理员可查看票数和明细',
    '投票结束后可看票数',
    '投票结束后可看票数和明细',
  ];
  var nmList = ['投票后可看票数', '仅管理员可查看票数', '投票结束后可看票数'];
  const rules = isBe ? nmList : defalutList;
  const ruleMap = [];
  for (let k in rules) {
    ruleMap.push({ value: k, label: rules[k] });
  }
  return ruleMap;
};

export const canResultDetail = function (publishResult, publishResultLicensee, isFinish) {
  var isBe = false;
  if (publishResultLicensee === null) {
    if (publishResult) {
      isBe = true;
    }
  } else {
    publishResultLicensee = parseInt(publishResultLicensee);
    if (publishResultLicensee === 1 || publishResultLicensee === 2) {
      isBe = true;
    } else if (publishResultLicensee === 4) {
      isBe = isFinish ? true : false;
    }
  }

  return isBe;
};

// 选择题通过传入options和选则的选项，返回具体的值
export const getOptionByValue = function (options, value) {
  var result = '';
  if (options && options.length > 0 && value) {
    var vals = value.split(',');
    var results = [];
    for (var i = 0; i < vals.length; i++) {
      results.push(options[parseInt(vals[i])]);
    }
    result = results.join(',');
  }
  return result;
};

export const getFormatDuration = function (mss) {
  // 单位为ms
  var days = parseInt(mss / (1000 * 60 * 60 * 24));
  var hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = parseInt((mss % (1000 * 60)) / 1000);
  return (
    (days > 0 ? days + '天' : '') +
    (hours > 0 ? hours + '小时' : '') +
    (minutes > 0 ? minutes + '分钟' : '') +
    (seconds > 0 ? seconds + '秒' : '')
  );
};

export const getExamScore = function (examForms, name) {
  var total = 0;
  if (examForms && examForms.length > 0) {
    for (var e = 0; e < examForms.length; e++) {
      total += parseInt(examForms[e][name]);
    }
  }
  return total;
};

export const hasDot = function (num) {
  if (!isNaN(num)) {
    return (num + '').indexOf('.') !== -1 ? num.toFixed(1) : num;
  }
};

export const intersection = function (a, b) {
  var out = [];
  for (var i = 0; i < a.length; i++) {
    if (b.indexOf(a[i]) > -1) {
      out.push(a[i]);
    }
  }
  return out;
};

// 星期过滤器 - 将数字1-7转换为周一到周日
export const weekdayFilter = (weekday) => {
  const weekdays = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
  if (weekday >= 1 && weekday <= 7) {
    return weekdays[weekday - 1];
  }
  return '';
};

// 创建课程映射 - 将课程数组转换为以id为key的对象
export const createCourseSettingMap = (courseSetting) => {
  if (!courseSetting || courseSetting.length === 0) {
    return {};
  }
  const courseSettingMap = {};
  for (let i = 0; i < courseSetting.length; i++) {
    const course = courseSetting[i];
    courseSettingMap[course.id] = course;
  }
  return courseSettingMap;
};

// 格式化价格（分转元）
export const formatPrice = (priceInCents) => {
  if (!priceInCents && priceInCents !== 0) return '0.00';
  return (priceInCents / 100).toFixed(2);
};

// 格式化授课时间显示
export const formatCourseSchedule = (schedule) => {
  if (!schedule || schedule.length === 0) return '未设置';
  return schedule
    .map((s) => {
      return `${weekdayFilter(s.dayOfWeek)} ${s.startTime}-${s.endTime}`;
    })
    .join('、');
};

// 判断课程是否在当前日期筛选中可见
export const isCourseVisibleByDate = (course, currentDateFilter) => {
  if (!currentDateFilter || currentDateFilter === 'all') return true;
  if (!course.schedule || course.schedule.length === 0) return true;

  const filterDay = parseInt(currentDateFilter);
  return course.schedule.some((s) => s.dayOfWeek === filterDay);
};

// 获取筛选后的课程列表
export const getVisibleCourses = (courseSetting, currentDateFilter) => {
  if (!courseSetting || courseSetting.length === 0) return [];
  return courseSetting.filter((course) => isCourseVisibleByDate(course, currentDateFilter));
};

// 获取剩余名额显示文本
export const getCourseQuotaText = (quota) => {
  if (quota === 0) return '不限';
  if (quota > 0) return `剩余${quota}名额`;
  return '';
};

// 提交统计/表单前清洗 infoForms：兼容旧格式（formId / showForms）数据
// - 删除旧格式 showForms 字段（后端 input 不识别）
// - showConditions 每条仅保留 optionId / optionIdxs / optionLogic，删除非法 formId 等字段；
//   缺失 optionId 的旧条目整条丢弃（旧显示条件丢失，需在前端重配）
// - 递归处理自增表格（type=19）的 groupInfoForms
export const cleanInfoFormsForSubmit = (infoForms) => {
  if (!Array.isArray(infoForms)) return infoForms;
  return infoForms.map((form) => {
    if (!form || typeof form !== 'object') return form;
    const next = { ...form };
    // 旧格式字段，后端不接受，直接删除
    delete next.showForms;
    if (Array.isArray(next.showConditions)) {
      next.showConditions = next.showConditions
        .filter((c) => c && c.optionId)
        .map((c) => ({
          optionId: c.optionId,
          optionIdxs: c.optionIdxs,
          optionLogic: c.optionLogic || 0,
        }));
    } else {
      next.showConditions = [];
    }
    if (Array.isArray(next.groupInfoForms)) {
      next.groupInfoForms = cleanInfoFormsForSubmit(next.groupInfoForms);
    }
    return next;
  });
};

// 全局展示模式：合并同名课程的schedule
export const getGlobalCourseList = (courseSetting) => {
  if (!courseSetting || courseSetting.length === 0) return [];

  const courseMap = {};
  const result = [];

  courseSetting.forEach((course) => {
    const title = course.title || '未命名课程';
    if (courseMap[title]) {
      const existing = courseMap[title];
      if (course.schedule && course.schedule.length > 0) {
        existing.schedule = [...(existing.schedule || []), ...course.schedule];
      }
    } else {
      courseMap[title] = { ...course };
      result.push(courseMap[title]);
    }
  });

  return result;
};

// 计算 UTF-8 字符串的字节长度
export const byteLength = (str) => {
  let s = str.length;
  for (let i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;
    else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xdc00 && code <= 0xdfff) i--; // trail surrogate
  }
  return s;
};
